import { restClient } from '../config/restClient'

const endpoint = interviewRequestId => `/api/company/v2/interview_requests/${interviewRequestId}/greenhouse_profile`

export const getGreenhouseProfile = async interviewRequestId => {
  const response = await restClient(endpoint(interviewRequestId), {
    method: 'GET',
  })
  return response.data
}
